module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Row', {
    staticClass: "code-row-bg",
    attrs: {
      "type": "flex",
      "justify": "space-between"
    }
  }, [_c('Col', {
    attrs: {
      "span": "3"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isReceivedDo),
      expression: "isReceivedDo"
    }],
    attrs: {
      "type": "checkbox",
      "id": _vm.invoice.invoiceid
    },
    domProps: {
      "checked": Array.isArray(_vm.isReceivedDo) ? _vm._i(_vm.isReceivedDo, null) > -1 : (_vm.isReceivedDo)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.isReceivedDo,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isReceivedDo = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.isReceivedDo = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isReceivedDo = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": _vm.invoice.invoiceid
    }
  }, [_vm._v(_vm._s(_vm.invoice.markingheadercode))])]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "2"
    }
  }, [_vm._v("Ctns " + _vm._s(_vm.invoice.totalctns))]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "1"
    }
  }, [(_vm.invoice.invoiceReceiveDo.length > 0) ? _c('Poptip', {
    attrs: {
      "placement": "top",
      "trigger": "hover"
    }
  }, [_c('Button', {
    attrs: {
      "type": "info",
      "size": "small"
    }
  }, [_vm._v(_vm._s(_vm.invoice.invoiceReceiveDo.length))]), _vm._v(" "), _c('div', {
    staticClass: "api",
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('ul', _vm._l((_vm.invoice.invoiceReceiveDo), function(item) {
    return _c('li', [_vm._v("\n                            - " + _vm._s(item.notes) + "\n                        ")])
  }), 0)])], 1) : _vm._e()], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "16"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "Notes..",
      "size": "small"
    },
    model: {
      value: (_vm.notes),
      callback: function($$v) {
        _vm.notes = $$v
      },
      expression: "notes"
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-558fd648","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/invoice/cInvoiceReceiveRow.vue
// module id = 1811
// module chunks = 1